export const projects = [
  {
    title: "Rize Virtual, LLC",
    subtitle: "Wordpress",
    description:
      "Custom Wordpress website for my own web design agency featuring Bootstrap CSS, chat and scheduling integration.",
    image: "./RizeVirtual.gif",
    link: "https://rizevirtual.com",
  },
  {
    title: "Builders Command, LLC",
    subtitle: "Wordpress",
    description:
      "Custom Wordpress website built for a small contracting/home remodeling company featuring an interactive service map.",
    image: "./BuildersCommand.gif",
    link: "https://builderscommand.com",
  },
  {
    title: "TNT's Sports Bar and Grill",
    subtitle: "Wordpress",
    description:
      "Wordpress website for restaurant/bar featuring menu, social media follow, online ordering, gallery and event calendar.",
    image: "./TNTSportsBar.gif",
    link: "https://tntsportsbarandgrill.com",
  },
];

export const testimonials = [
  {
    quote:
      "Rize Virtual has been extremely helpful, and informative with the industry. I personally am not a professional in this area so I knew I needed to find one. Couldn’t be happier with my choice for my company. Thank you for all your continued help.",
    name: "Josh Russell",
    company: "Builders Command",
  },
  {
    quote:
      "Sarah has been most helpful in designing our website and I would highly recommend her to any business looking for a new website or to upgrade your current one.",
    name: "Tim Metropulos",
    company: "TNT's Sports Bar & Grill",
  },
];

export const skills = [
  "JavaScript",
  "React",
  "jQuery",
  "Bootstrap",
  "eCommerce",
  "Python",
];



// WEBPACK FOOTER //
// ./src/data.js